export const authAction = {
    AUTH_CHECKED: 'AUTH_CHECKED',
    AUTH_LOGIN: 'AUTH_LOGIN',
    AUTH_LOGOUT: 'AUTH_LOGOUT',
}

export const dashboardAction = {
    DASHBOARD_INITIATE: 'DASHBOARD_INITIATE',
    DASHBOARD_SUCCESS: 'DASHBOARD_SUCCESS',
    DASHBOARD_FAILURE: 'DASHBOARD_FAILURE',
}

export const itemAction = {
    ITEM_LIST_INITIATE: 'ITEM_LIST_INITIATE',
    ITEM_LIST_SUCCESS: 'ITEM_LIST_SUCCESS',
    ITEM_LIST_FAILURE: 'ITEM_LIST_FAILURE',

    ITEM_OPTIONS_SUCCESS: 'ITEM_OPTIONS_SUCCESS',
}

export const documentAction = {
    DOCUMENT_LIST_INITIATE: 'DOCUMENT_LIST_INITIATE',
    DOCUMENT_LIST_SUCCESS: 'DOCUMENT_LIST_SUCCESS',
    DOCUMENT_LIST_FAILURE: 'DOCUMENT_LIST_FAILURE',

    DOCUMENT_UPLOAD_INITIATE: 'DOCUMENT_UPLOAD_INITIATE',
    DOCUMENT_UPLOAD_PROGRESS: 'DOCUMENT_UPLOAD_PROGRESS',
    DOCUMENT_UPLOAD_SUCCESS: 'DOCUMENT_UPLOAD_SUCCESS',
    DOCUMENT_UPLOAD_FAILURE: 'DOCUMENT_UPLOAD_FAILURE',
}
